import { VITE_ENV_NAME } from '@/shared/lib/env';

const getEnvironmentStyle = (envName: string) => {
  // ローカル開発（vite dev mode）は LOCAL を表示
  if (import.meta.env.DEV) {
    return {
      label: 'LOCAL',
      className: 'border-stone-200 bg-stone-100 text-stone-700',
    };
  }

  const normalized = envName.toLowerCase();

  if (normalized === 'dev') {
    return {
      label: 'DEV',
      className: 'border-sky-200 bg-sky-50 text-sky-700',
    };
  }

  if (normalized === 'stg') {
    return {
      label: 'STG',
      className: 'border-amber-200 bg-amber-50 text-amber-700',
    };
  }

  if (normalized === 'preprod') {
    return {
      label: 'PREPROD',
      className: 'border-violet-200 bg-violet-50 text-violet-700',
    };
  }

  // VITE_ENV_NAME 未設定や想定外の値は PROD として扱う（client は元仕様で PROD 非表示）
  return null;
};

export const EnvironmentIndicator = () => {
  const indicator = getEnvironmentStyle(VITE_ENV_NAME);
  if (!indicator) {
    return null;
  }

  const { label, className } = indicator;

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 font-semibold text-xs leading-none tracking-wide ${className}`}
    >
      {label}
    </span>
  );
};
